<ng-container *transloco="let convert;">
  <div [id]="'multi-select' + componentId" class="dropDown">
    <div id="multiple_yellow_lights" (keydown.escape)="showDropDown = false">
      <button class="drop-toggle" (click)="showDropDown=!showDropDown" [ngClass]="{'required-item-error': isRequired && getSelectedItemCount() === 0}" >
        <em class="allycon-glyph-chevron-down text-primary ms-2"></em>
        <span class="yellow-light-selections">{{getSelection()}}</span>
      </button>
      @if (isRequired && getSelectedItemCount() === 0) {
        <span class="required-item-error-message">
          {{convert('sellModule.posting.multiSelectorDropdown.textYellowLight')}}
        </span>
      }
      @if (showDropDown) {
        <div class="control-wrapper form-group drop-show" #checkboxes>
          <trap-focus [enableFocusTrap]="showDropDown" [enableArrowKeys]="true">
            <fieldset [attr.aria-label]="convert('sellModule.posting.multiSelectorDropdown.ariaLabelLightSelection')">
              <legend hidden>{{convert('sellModule.posting.multiSelectorDropdown.ariaLabelLightSelection')}}</legend>
              @for (a of list; track a) {
                <div class="custom-control custom-checkbox checkboxes" title="{{a.disclosureDescription}}">
                  <input type="checkbox" class="custom-control-input excludes__input" [(ngModel)]="a.selected"
                    (change)="getSelectedValue(a.selected,a.disclosureDescription)" id="{{a.disclosureDescription}}" />
                  <label class="custom-control-label excludes__label checkbox-labels"
                  for="{{a.disclosureDescription}}">{{a.disclosureDescription}}</label>
                </div>
              }
            </fieldset>
          </trap-focus>
        </div>
      }
    </div>
  </div>
</ng-container>
